import { useEffect } from 'react';

/** Suppresses pinch-zoom, double-tap zoom, and the context menu — kiosk hardening. */
export function usePreventZoom(): void {
  useEffect(() => {
    const preventGesture = (e: Event) => e.preventDefault();
    const preventMultiTouch = (e: TouchEvent) => {
      if (e.touches.length > 1) e.preventDefault();
    };

    document.addEventListener('gesturestart', preventGesture);
    document.addEventListener('contextmenu', preventGesture);
    document.addEventListener('touchmove', preventMultiTouch, { passive: false });
    return () => {
      document.removeEventListener('gesturestart', preventGesture);
      document.removeEventListener('contextmenu', preventGesture);
      document.removeEventListener('touchmove', preventMultiTouch);
    };
  }, []);
}
